import React from "react";
import { useNavigate } from 'react-router-dom';
import ListProxyOnComponent from "../../../components/Customer/proxies/ListProxyOnComponent";

const ListProxyOnPage = () => {

    const navigate = useNavigate();

    let redirectChangeUser = (listVps) => {
        navigate('/dich-vu-proxy/chuyen-khach-hang.html?' + listVps);
    }

    return <ListProxyOnComponent
        redirectChangeUser={ (listVps) => redirectChangeUser(listVps) }
    />

}

export default ListProxyOnPage;